function addEvent(obj, evt, fn) {
    if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false);
    }
    else if (obj.attachEvent) {
        obj.attachEvent("on" + evt, fn);
    }
}

// comment out the Newsletter modal popup on screenleave because there is another modal from Hubspot

// addEvent(document, "mouseout", function(e) {
//     e = e ? e : window.event;
//     var from = e.relatedTarget || e.toElement;
//     if (!from || from.nodeName == "HTML") {
//       if (readCookie('newsletter')!="seen") {
//         jQuery('.newsletter-modal__wrapper').fadeIn();
//         gtag('event','popup_view',{'event_action':'View Newsletter Popup'});
//       }
//     }
// });

(function($) {

$(document).ready(function(){  
  $('[href="#newsletter"]').on('click',function(){
    $('.newsletter-modal__wrapper').fadeIn();
    gtag('event','popup_view',{'event_action':'View Newsletter Popup'});
  });
  $('.newsletter-modal__wrapper').on('click',function(e){
    if ($(e.target).hasClass('newsletter-modal__wrapper')) {
      $('.newsletter-modal__wrapper').fadeOut();
      newCookie('newsletter','seen',1);
    }
  });  
  $('.newsletter-modal__close').on('click',function(){
    $('.newsletter-modal__wrapper').fadeOut();
    newCookie('newsletter','seen',1);
  });
  if ($('.single-post').length) {
    $(window).scroll(function() {
      if($(window).scrollTop() + $(window).height() == $(document).height() && readCookie('newsletter')!="seen") {
        $('.newsletter-modal__wrapper').fadeIn();
        gtag('event','popup_view',{'event_action':'View Newsletter Popup'});
        newCookie('newsletter','seen',1);
      }
    });
  }
});

})( jQuery );  

function newCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString(); }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/"; 
}
function readCookie(name) {
  var nameSG = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
  var c = ca[i];
  while (c.charAt(0)==' ') c = c.substring(1,c.length);
  if (c.indexOf(nameSG) == 0) return c.substring(nameSG.length,c.length); }
  return null; 
}